import { useEffect, useState } from "react";
import api, { rupiah, errMsg } from "../lib/api";
import { Tags, Check, Search } from "lucide-react";
import { toast } from "sonner";

export default function PriceList() {
  const [items, setItems] = useState([]);
  const [edits, setEdits] = useState({});
  const [q, setQ] = useState("");

  const load = () => api.get("/items").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async (i) => {
    const val = edits[i.id];
    if (val === undefined) return;
    try {
      await api.put(`/items/${i.id}`, { sell_price: Number(val) });
      toast.success("Harga jual disimpan");
      setEdits((s) => { const c = { ...s }; delete c[i.id]; return c; });
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const filtered = items.filter((i) =>
    (i.name + (i.warna || "")).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5 animate-fadeup">
      <div>
        <h1 className="text-2xl sm:text-3xl font-display font-extrabold">Daftar Harga</h1>
        <p className="text-[#52525B] text-sm">Produk, warna & harga jual</p>
      </div>

      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#52525B]" />
        <input data-testid="price-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari produk / warna…" className="nb-input pl-9" />
      </div>

      {filtered.length === 0 ? (
        <div className="nb-card p-10 text-center text-[#52525B]"><Tags className="w-10 h-10 mx-auto mb-3" />Tidak ada produk.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 items-start">
          {filtered.map((i) => {
            const val = edits[i.id] ?? i.sell_price;
            const changed = edits[i.id] !== undefined;
            return (
              <div key={i.id} data-testid={`price-card-${i.id}`} className="nb-card p-4">
                <div className="font-display font-bold text-lg truncate">{i.name}</div>
                <span className="label-tag">{i.warna || "—"}</span>
                <div className="mt-3">
                  <label className="label-tag block mb-1">Harga Jual</label>
                  <div className="flex gap-2">
                    <input data-testid={`price-sell-${i.id}`} type="number" min="0" className="nb-input" value={val} onChange={(e) => setEdits((s) => ({ ...s, [i.id]: e.target.value }))} />
                    {changed && (
                      <button data-testid={`price-save-${i.id}`} onClick={() => save(i)} className="nb-btn px-3 shrink-0 text-[#0A0A0A]" style={{ background: "var(--primary)" }}><Check className="w-4 h-4" /></button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
